import { render, staticRenderFns } from "./DeclaracaoDctfWebView.vue?vue&type=template&id=32864638&"
import script from "./DeclaracaoDctfWebView.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoDctfWebView.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoDctfWebView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports